import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { BaivietAction } from 'src/actions/baiviet.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.baiviet)

    const [title, setTitle] = useState("");
    const [title_font, setTitleFont] = useState("-99");
    const [title_font_size, setTitleFontSize] = useState("-99");
    const [short_description, setShortDescription] = useState("");
    const [short_description_font, setShortDescriptionFont] = useState("-99");
    const [short_description_font_size, setShortDescriptionFontSize] = useState("-99");
    const [content, setContent] = useState("");
    const [image, setImage] = useState("");
    const [loai_bai, setLoaiBai] = useState("bai_viet");
    const [noi_bat, setNoiBat] = useState(2);

    const handleImageUpload = (imageUrl) => {
        setImage(imageUrl);
    };

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
        dispatch(PermissionAction.list(0, 100))
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setTitle(selected.title)
                setTitleFont(selected.title_font)
                setTitleFontSize(selected.title_font_size)
                setShortDescription(selected.short_description)
                setShortDescriptionFont(selected.short_description_font)
                setShortDescriptionFontSize(selected.short_description_font_size)
                setContent(selected.content)
                setImage(selected.image)
                setLoaiBai(selected.loai_bai)
                setNoiBat(selected.noi_bat)
            }
        }
    }, [selected])

    const onPressPositive = async () => {
        console.log("image:", image);
        console.log("content:", content);

        if (title === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (short_description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (content === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (image === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (loai_bai === "" || loai_bai == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (noi_bat === "" || noi_bat == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (props.type === 'EDIT') {
            dispatch(BaivietAction.update(selected.id, { 
                title, 
                title_font: title_font !== "" && title_font != "-99" ? title_font : null,
                title_font_size: title_font_size !== "" && title_font_size != "-99" ? title_font_size : null,
                short_description, 
                short_description_font: short_description_font !== "" && short_description_font != "-99" ? short_description_font : null,
                short_description_font_size: short_description_font_size !== "" && short_description_font_size != "-99" ? short_description_font_size : null,
                content, 
                image, 
                loai_bai, 
                noi_bat 
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(BaivietAction.create({ 
                    title, 
                    title_font: title_font !== "" && title_font != "-99" ? title_font : "",
                    title_font_size: title_font_size !== "" && title_font_size != "-99" ? title_font_size : "",
                    short_description, 
                    short_description_font: short_description_font !== "" && short_description_font != "-99" ? short_description_font : "",
                    short_description_font_size: short_description_font_size !== "" && short_description_font_size != "-99" ? short_description_font_size : "", 
                    content, 
                    image, 
                    loai_bai, 
                    noi_bat 
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
        
    }

    const resetState = () => {
        setTitle("")
        setTitleFont("-99")
        setTitleFontSize("-99")
        setShortDescription("")
        setShortDescriptionFont("-99")
        setShortDescriptionFontSize("-99")
        setContent("")
        setImage("")
        setLoaiBai("bai_viet")
        setNoiBat(2)
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedPermissionIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds, id);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(1));
        } else if (selectedIndex === selectedPermissionIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedPermissionIds.slice(0, selectedIndex),
                selectedPermissionIds.slice(selectedIndex + 1)
            );
        }
        setSelectedPermissionIds(newSelectedCustomerIds);
    };

    const setColor = (value) => {
        if (value == 'co_noi_bat') return '#FF0000';
        else if (value == 'khong_noi_bat') return '#000000';
        else if (value == 'bai_viet') return '#037319';
        else if (value == 'tin_tuc') return '#0000FF';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Tiêu đề bài đăng"
                                name="title"
                                onChange={(e) => setTitle(e.target.value)}
                                required
                                value={title}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="title_font"
                                value={title_font || -99}
                                onChange={(e) => setTitleFont(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Font tiêu đề...</MenuItem>
                                {POST_EDITOR_FONTS.map((value, index) => (
                                    <MenuItem value={value}>{value}</MenuItem>
                                ))}
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="title_font_size"
                                value={title_font_size || -99}
                                onChange={(e) => setTitleFontSize(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Cỡ chữ tiêu đề...</MenuItem>
                                {POST_EDITOR_FONT_SIZES.map((value, index) => (
                                    <MenuItem value={parseInt(value)}>{value}</MenuItem>
                                ))}
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Mô tả ngắn"
                                name="short_description"
                                onChange={(e) => setShortDescription(e.target.value)}
                                required
                                value={short_description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="short_description_font"
                                value={short_description_font || -99}
                                onChange={(e) => setShortDescriptionFont(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Font mô tả ngắn...</MenuItem>
                                {POST_EDITOR_FONTS.map((value, index) => (
                                    <MenuItem value={value}>{value}</MenuItem>
                                ))}
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="short_description_font_size"
                                value={short_description_font_size || -99}
                                onChange={(e) => setShortDescriptionFontSize(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Cỡ chữ mô tả ngắn...</MenuItem>
                                {POST_EDITOR_FONT_SIZES.map((value, index) => (
                                    <MenuItem value={parseInt(value)}>{value}</MenuItem>
                                ))}
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="loai_bai"
                                value={loai_bai || -99}
                                onChange={(e) => setLoaiBai(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Loại bài...</MenuItem>
                                <MenuItem value="bai_viet" style={{color: setColor('bai_viet')}}>Loại: Bài viết</MenuItem>
                                <MenuItem value="tin_tuc" style={{color: setColor('tin_tuc')}}>Loại: Tin tức</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="noi_bat"
                                value={noi_bat || -99}
                                onChange={(e) => setNoiBat(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Nổi bật...</MenuItem>
                                <MenuItem value="1" style={{color: setColor('co_noi_bat')}}>Có nổi bật</MenuItem>
                                <MenuItem value="2" style={{color: setColor('khong_noi_bat')}}>Không nổi bật</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Hình ảnh *
                            </Typography>
                            <div style={{width: "100%"}}>
                                <ImageUploader 
                                    onUploadSuccess={handleImageUpload} 
                                    initialImage={image !== "" ? image : ""}
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Nội dung bài viết *
                            </Typography>
                            <div>
                                <PostEditor
                                    onChange={(value) => {
                                        setContent(value);
                                    }}
                                    initialContent={content !== "" ? content : ""}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;